var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns transformed flow by appending deprecated fields expected by the
 * endpoint.
 *
 * @param flow The flow to transform.
 */
export function transformFlowCreateOrUpdate(flow) {
    return Object.assign(Object.assign({}, flow), { actions: flow.actions.map((_a) => {
            var { wait_music } = _a, action = __rest(_a, ["wait_music"]);
            return (Object.assign(Object.assign(Object.assign({}, action), { text: '', icon: '', isAction: false, overlay: [], badges: [] }), (!!wait_music && { wait_music_v2: wait_music })));
        }) });
}
